import { render, staticRenderFns } from "./BaseFormRadio.vue?vue&type=template&id=5b6ae138"
import script from "./BaseFormRadio.vue?vue&type=script&lang=js"
export * from "./BaseFormRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports